const returnWithReason = {
    namespaced: true,
    state: {
        visible: false,
        resolve: null,
        reject: null,

        title: null,
        reason: null,
        attachment: null
    },
    mutations: {
        SET_VISIBLE(state, payload) {
            state.visible = payload;
        },
        SET_RESOLVE(state, payload) {
            state.resolve = payload;
        },
        SET_REJECT(state, payload) {
            state.reject = payload;
        },
        SET_REASON(state, payload) {
            state.reason = payload;
        },
        SET_TITLE(state, payload) {
            state.title = payload ?? "Причина_возврата";
        },
        SET_ATTACHMENT(state, payload) {
            state.attachment = payload;
        }
    },
    actions: {
        async open({ commit }, {title}) {
            commit('SET_REASON', null);
            commit('SET_TITLE', title);
            commit('SET_ATTACHMENT', null);
            commit('SET_VISIBLE', true);
            
            return new Promise((resolve, reject) => {
                commit('SET_RESOLVE', resolve);
                commit('SET_REJECT', reject);
            });
        },
        async ok({ commit, state }) {
            commit('SET_VISIBLE', false);

            let result =  {
                reason: state.reason,
                attachment: state.attachment
            };

            state.resolve(result);
        },
        async cancel({ commit, state }) {
            commit('SET_VISIBLE', false);
            state.reject({ message: "Cancelled" });
        },
    },
    getters: {
        isVisible: (s) => s.visible,
        getTitle: (s) => s.title,
        getReason: (s) => s.reason,
        getAttachment: (s) => s.attachment,
    }
}

export default returnWithReason;